<template>
  <div class="folder-upload-container">
    <!-- 上传按钮 -->
    <div class="upload-section">
      <input
        type="file"
        id="folderInput"
        webkitdirectory
        multiple
        @change="handleFolderSelect"
        style="display: none"
      />
      <a-button @click="triggerFolderSelect" :disabled="uploading">
        {{ uploading ? '上传中...' : '上传文件夹' }}
      </a-button>
    </div>

    <!-- 总进度条 -->
    <div v-if="uploading" class="overall-progress">
      <div style="display:flex;gap:10px;">
        <h6 style="flex-shrink:0;">总进度</h6>
        <div class="progress-stats" style="width:100%">
          <span>{{ overallProgress }}%</span>
          <span>{{ uploadedCount }}/{{ totalFiles }} 个文件</span>
        </div>
      </div>
      <div class="progress-container">
        <div class="progress-bar" :style="{ width: overallProgress + '%' }"></div>
      </div>
      
    </div>

    <!-- 文件列表 -->
    <div v-if="fileList.length > 0" class="file-list">
      <h6>文件上传详情</h6>
      <div style="width:100%;display:flex;flex-wrap:wrap;gap:5px;">
        <div class="file-item" v-for="file in fileList" :key="file.id">
          <div class="file-info" style="width: 100%;overflow: hidden;">
            <div style="display:flex;align-items:center;gap:2px;flex:auto;width:100%;overflow: hidden;">
              <div class="file-status">
                <span class="status-badge" :class="file.status">
                  {{ getStatusText(file.status) }}
                  <span v-if="file.status === 'uploading'">{{ file.progress + '%' }}</span>
                  <span v-if="file.error" class="error-msg">{{ file.error }}</span>
                </span>
              </div>
              <span class="file-name">{{ file.name }}</span>
            </div>
            <span class="file-size" style="flex-shrink: 0;">{{ formatFileSize(file.size) }}</span>
          </div>
          
        </div>
      </div>
    </div>

    <!-- 上传结果 -->
    <!-- <div v-if="uploadComplete" class="upload-result">
      <div class="result-summary" :class="uploadResult.success ? 'success' : 'warning'">
        <h3>
          {{ uploadResult.success ? '✅ 上传完成' : '⚠️ 上传完成，但有文件失败' }}
        </h3>
        <p style="margin:0">{{ uploadResult.message }}</p>
        <div class="result-stats">
          <span>成功: {{ successCount }}</span>
          <span>失败: {{ failedCount }}</span>
          <span>总计: {{ totalFiles }}</span>
        </div>
        
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { defineEmits, ref, computed, defineProps, onMounted, defineExpose} from 'vue';
import OSS from 'ali-oss'
import request from '@/utils/request'
import { message,Modal } from 'ant-design-vue';
import dayjs from 'dayjs';
import {checkVideo} from '@/utils/tools'

// 状态定义
const uploading = ref(false)
const uploadComplete = ref(false)
const verifying = ref(false)
const totalFiles = ref(0)
const uploadedCount = ref(0)
const failedFiles = ref([])
const successFiles = ref([])

// 文件列表
const fileList = ref([])

// OSS 客户端
let ossClient = null

// 计算属性
const overallProgress = computed(() => {
  if (totalFiles.value === 0) return 0
  return Math.floor((uploadedCount.value / totalFiles.value) * 100)
})

const successCount = computed(() => {
  return fileList.value.filter(f => f.status === 'success').length
})

const failedCount = computed(() => {
  return fileList.value.filter(f => f.status === 'error').length
})

const uploadResult = computed(() => {
  const total = fileList.value.length
  const success = successCount.value
  const failed = failedCount.value
  
  if (total === 0) {
    return { success: false, message: '没有文件需要上传' }
  }
  
  if (success === total) {
    return { 
      success: true, 
      message: `所有 ${total} 个文件上传成功！` 
    }
  }
  
  return {
    success: false,
    message: `上传完成：${success} 成功，${failed} 失败`
  }
})

const verificationResult = ref(null)
function reset() {

}
// 方法
const triggerFolderSelect = () => {
  document.getElementById('folderInput').click()
}

const handleFolderSelect = async (event) => {
  resetState()
  
  const files = Array.from(event.target.files)
  
  if (files.length === 0) return
  
  // 初始化文件列表
  fileList.value = files.map((file, index) => ({
    id: `${Date.now()}_${index}`,
    file: file,
    name: file.name,
    relativePath: file.webkitRelativePath || file.name,
    size: file.size,
    status: 'pending',
    progress: 0,
    error: null
  })).filter(v=>!v.name.startsWith('.DS_'))

  totalFiles.value = fileList.value.length
  console.log(fileList.value)
  // 初始化 OSS 客户端
  // await initOSSClient()
}

function generateUUID() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
const initOSSClient = async () => {
  // 这里需要从你的后端获取 OSS 凭证
  try {
    const sts = await request.post(`/api/aliyun/sts`, {}, 'no')
    if (sts.error) {
        message.error(`存储服务授权失败:` + sts.error.message)
        return
    }
    ossClient =  new OSS({
        accessKeyId: sts.data.AccessKeyId,
        accessKeySecret: sts.data.AccessKeySecret,
        stsToken: sts.data.SecurityToken,
        // bucket: 'marsvision',
        bucket: 'koc-cpe',
        region: 'oss-cn-beijing',
    });


    startUpload()

  } catch (error) {
    message.error('OSS 初始化失败: ' + error.message)
  }
}


const startUpload = async () => {
  if (!ossClient || fileList.value.length === 0) {
    message.error('请先选择文件夹并初始化 OSS')
    return
  }
  
  uploading.value = true
  uploadComplete.value = false
  failedFiles.value = []
  successFiles.value = []
  uploadedCount.value = 0
  
  // 控制并发数
  const CONCURRENT_LIMIT = 3
  const queue = [...fileList.value.filter(f => f.status !== 'success')]
  
  while (queue.length > 0) {
    const batch = queue.splice(0, CONCURRENT_LIMIT)
    await Promise.allSettled(
      batch.map(file => uploadSingleFile(file))
    )
  }
  
  uploading.value = false
  uploadComplete.value = true
  
  // 检查上传结果
  checkUploadCompletion()
  emits('finished')
}

const uploadSingleFile = async (fileInfo) => {
  fileInfo.status = 'uploading'
  
  try {
    
    let newName = `${fileInfo.file.name}`

    let originName = fileInfo.file.name.split('.')
    let fileName = originName.slice(0,-1).join('.')
    let fileType = originName.slice(-1)
    const ossPath = 'marsvision/koc_cpe/batch_material/'+generateUUID()+'.'+fileType
    let isVideo = checkVideo(fileInfo.file.name)
    let header = {}
    if (isVideo) {
      header = {
        mime: 'video/mp4',                // ← 最简单的写法，ali-oss 会把它当 Content-Type 存进 OSS
        headers: {
          'Content-Disposition': 'inline' // ← 顺手把这个也带上，防止 OSS 端强制下载
        },
      }
    }
    const result = await ossClient.multipartUpload(ossPath, fileInfo.file, {
      progress: async (percentage) => {
        fileInfo.progress = Math.floor(percentage * 100)
      },
      // mime: fileInfo.file.type,
      partSize: 1024 * 1024, // 1MB 分片
      ...header,
    })
    

    var url = "http://koc_cpe.oss-cn-beijing.aliyuncs.com/" // 待定

    fileInfo.status = 'success'
    successFiles.value.push({
        path: fileInfo.relativePath,
        ossPath: ossPath,
        size: fileInfo.size,
        showUrl: url+result.name,
        url: ossPath,
        fileName: newName
    })

    console.log(555, result, successFiles.value)
    
  } catch (error) {
    fileInfo.status = 'error'
    fileInfo.error = error.message
    
    failedFiles.value.push({
      path: fileInfo.relativePath,
      error: error.message,
      file: fileInfo.file
    })
  } finally {
    uploadedCount.value++
  }
}

const checkUploadCompletion = () => {
  const pendingFiles = fileList.value.filter(f => f.status === 'pending')
  const uploadingFiles = fileList.value.filter(f => f.status === 'uploading')
  
  if (pendingFiles.length === 0 && uploadingFiles.length === 0) {
    console.log('所有文件上传处理完成')
  }
}

const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

const getStatusText = (status) => {
  const texts = {
    pending: '等待',
    uploading: '上传中',
    success: '成功',
    error: '失败'
  }
  return texts[status] || status
}

const resetState = () => {
  uploading.value = false
  uploadComplete.value = false
  verifying.value = false
  totalFiles.value = 0
  uploadedCount.value = 0
  failedFiles.value = []
  successFiles.value = []
  fileList.value = []
  verificationResult.value = null
}


defineExpose({
  successFiles,
  uploadComplete,
  fileList,
  resetState,
  initOSSClient,
});

const emits = defineEmits(['finished'])
</script>

<style scoped>
.folder-upload-container {
  width: 100%;
}

.upload-section button {
  padding: 4px 12px;
  background: #275bff;
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
}

.upload-section button:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

.folder-info {
  margin: 20px 0;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #007bff;
}

.folder-info h3 {
  margin-top: 0;
  color: #333;
}

.start-btn {
  padding: 8px 16px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

.start-btn:disabled {
  background: #cccccc;
}

.overall-progress {
  margin: 10px 0;
  padding: 10px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.progress-container {
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin: 6px 0 0;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #007bff, #0056b3);
  transition: width 0.3s ease;
}

.progress-stats {
  display: flex;
  justify-content: space-between;
  color: #666;
  font-size: 12px;
}

.file-list {
  margin: 20px 0;
  max-height: 200px;
  overflow-y: auto;
}

.file-item {
  padding: 6px;
  /* margin: 4px 0; */
  background: white;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 32%;
}

.file-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.file-name {
  font-weight: 500;
  color: #333;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: auto;
  width: 100%;
}

.file-size {
  color: #666;
  font-size: 12px;
  margin-left: 10px;
}

.file-status {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 500;
  min-width: 50px;
  text-align: center;
}

.status-badge.pending {
  background: #f8f9fa;
  color: #666;
  border: 1px solid #dee2e6;
}

.status-badge.uploading {
  background: #e3f2fd;
  color: #1976d2;
}

.status-badge.success {
  background: #d4edda;
  color: #155724;
}

.status-badge.error {
  background: #f8d7da;
  color: #721c24;
}

.file-progress {
  flex: 1;
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
}

.file-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #007bff, #0056b3);
  transition: width 0.3s ease;
}

.error-msg {
  color: #dc3545;
  font-size: 12px;
  flex: 1;
}

.upload-result {
  margin-top: 30px;
}

.result-summary {
  padding: 10px;
  border-radius: 8px;
  border: 2px solid;
}

.result-summary.success {
  border-color: #28a745;
  background: #d4edda;
}

.result-summary.warning {
  border-color: #ffc107;
  background: #fff3cd;
}

.result-summary h3 {
  margin-top: 0;
  color: #155724;
}

.result-summary.warning h3 {
  color: #856404;
}

.result-stats {
  display: flex;
  gap: 20px;
  margin: 0;
  font-weight: bold;
}

.retry-section {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.retry-btn {
  padding: 8px 16px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.download-btn {
  padding: 8px 16px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.verification {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #dee2e6;
}

.verification button {
  padding: 8px 16px;
  background: #17a2b8;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.verification button:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

.verification-result {
  margin-top: 10px;
  padding: 10px;
  border-radius: 4px;
}

.verification-result .success {
  color: #155724;
  background: #d4edda;
  padding: 8px;
  border-radius: 4px;
}

.verification-result .error {
  color: #721c24;
  background: #f8d7da;
  padding: 8px;
  border-radius: 4px;
}
</style>